import { render, staticRenderFns } from "./DialogTaoPhieuChi.vue?vue&type=template&id=869bab8c"
import script from "./DialogTaoPhieuChi.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuChi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports